





































import Vue from "vue";
import { AudioDecoderPlayer } from "@joyz/app-core/utils/audio";

import { DrillState } from "@tt-app/models/exercise";
import DrillAnswerListening from "./DrillAnswerListening.vue";
import DrillAnswerPronunciation from "./DrillAnswerPronunciation.vue";
import DrillAnswerVocabulary from "./DrillAnswerVocabulary.vue";
import TranslationReviewSummaryItem from "@tt-app/components/exercise/drill/TranslationReviewSummaryItem.vue";

interface IpaDisplay {
  text: string;
  cssClass: string;
}

interface Props {
  audioDecoderPlayer: AudioDecoderPlayer;
  drill: DrillState;
}

export default Vue.extend<{}, {}, {}, Props>({
  name: "DrillReviewSummary",
  components: {
    DrillAnswerListening,
    DrillAnswerPronunciation,
    DrillAnswerVocabulary,
    TranslationReviewSummaryItem
  },

  props: {
    audioDecoderPlayer: { type: Object as () => AudioDecoderPlayer, required: true },
    drill: { type: Object as () => DrillState, required: true }
  }
});
